import DeviceSuggestionCard from '../DeviceSuggestionCard'
import useViewModel from './ProgramSuggestionCard.viewmodel'

export type Props = Parameters<typeof useViewModel>[0]

export default function ProgramSuggestionCard(props: Props) {
  const viewModel = useViewModel(props)
  const { displayName, isLoadingOrIdle, articles } = viewModel

  if (isLoadingOrIdle) {
    return null
  }

  return (
    <DeviceSuggestionCard
      iconName="Settings"
      title={displayName}
      articles={articles}
    />
  )
}
